<template>
  <b-row v-if="$route.name === 'ApplicationShow'">
    <b-col cols="12">
      <b-row class="mb-1">
        <b-col>
          <router-link tag="button" :to="{ name: 'ApplicationUpdate', params: { id: item['@id'] }}" class="btn btn-sm btn-warning">{{$t('buttons.edit')}}</router-link>
        </b-col>
        <b-col>
          <router-link tag="button" :to="{ name: 'ApplicationList', query: {p: currentPage} }" class="btn btn-sm btn-default float-right">{{$t('buttons.backToList')}}</router-link>
        </b-col>
      </b-row>
    </b-col>
    <b-col cols="12">
      <b-card>
        <template v-if="isLoading">
          <Loader></Loader>
        </template>
        <template v-else>
          <div v-if="item" class="pl-2">
            <div class="h6">
              <b> <span> {{item.subdomain}}.{{item.domain.domain}}</span> </b> - <span v-if="item['blockStatus'] === applicationStatuses.APPLICATION_BLOCK" style="color: #dc3545;"><i class="fa fa-lock fa-lg"></i></span>
              <span v-if="item['blockStatus'] === applicationStatuses.APPLICATION_UNBLOCK" style="color: #28a745;"><i class="fa fa-unlock fa-lg"></i></span>
              <span v-if="item['connectionStatus'] === applicationStatuses.CONNECTION_SUCCESS" v-b-tooltip.hover :title="$t('views.application.list.connectionSuccess')" style="color: #28a745" class="h6 ml-2 mt-0 mb-0"><i class="fa fa-circle fa-lg mr-2"></i></span>
              <span v-if="item['connectionStatus'] === applicationStatuses.CONNECTION_FAILURE" v-b-tooltip.hover :title="$t('views.application.list.connectionFailure')" style="color: #dc3545;" class="h6 ml-2 mt-0 mb-0"><i class="fa fa-circle fa-lg mr-2"></i></span>
            </div>
            <hr class="mt-1 mb-1">
            <div v-if="item">
              <p>
                <b>{{$t('routes.ApplicationShow')}}</b> - <a target="_blank" :href="'//' + item.subdomain + '.' +  item.domain.domain">{{ item.subdomain + '.' + item.domain.domain }}</a>
              </p>
              <p v-if="item.idUserData">
                <b>{{$t('views.application.form.idUserData')}}</b> -
                <router-link v-if="item.idUserData" :to="{ name: 'FirmShow', params: {id: item.idUserData['@id']} }">
                  {{ item.idUserData.firmname1 || item.idUserData.fullName }}
                </router-link>
              </p>
              <p v-if="item.createdAt">
                <b>{{$t('views.application.show.created')}}</b> - {{$moment(item.createdAt).format('YYYY-MM-DD HH:mm')}}
              </p>
              <p v-if="item.databaseConnection">
                <b>{{$t('views.application.show.databaseConnection')}}</b> - {{item.databaseConnection.title}}
              </p>
              <p v-if="item.server">
                <b>{{$t('views.application.show.server')}}</b> - {{item.server.title}}
              </p>
              <p v-if="item.SSHReturn" class="mb-0">
                <b>{{$t('views.application.show.SSHReturn')}}</b>
              </p>
              <b-table
                striped hover
                :bordered="true"
                :borderless="true"
                v-if="item.sqlScriptExecutedApplication && item.sqlScriptExecutedApplication.length > 0"
                :fields="executedApplicationFields"
                :items="item.sqlScriptExecutedApplication">
                <template v-slot:cell(createdAt)="data">
                  {{$moment(data.item.sqlScriptExecuted.createdAt).format(DATETIMEFORMATTYPE)}}
                </template>
                <template v-slot:cell(sqlScriptExecuted)="data">
                  <router-link :to="{name: 'SqlScriptExecutedShow', params: { id: data.item.sqlScriptExecuted['@id'] }}">
                    {{data.item.sqlScriptExecuted.sqlScript}}
                  </router-link>
                </template>
              </b-table>
              <active-agreements-chart-box v-if="item.externalData && item.externalData.activeAgreements" :data-incoming="item.externalData.activeAgreements"/>
              <active-user-datain-groups-chart-box v-if="item.externalData && item.externalData.activeGroupUserdata"  :data-incoming="item.externalData.activeGroupUserdata"/>
            </div>
          </div>
        </template>
      </b-card>
    </b-col>
  </b-row>
  <div v-else-if="item">
    <p>
      <b>{{$t('routes.ApplicationShow')}}</b> - <a target="_blank" :href="'//' + item.subdomain + '.' +  item.domain.domain">{{ item.subdomain + '.' + item.domain.domain }}</a>
    </p>
    <p v-if="item.createdAt">
      <b>{{$t('views.application.show.created')}}</b> - {{$moment(item.createdAt).format('YYYY-MM-DD HH:mm')}}
    </p>
    <p v-if="item.databaseConnection">
      <b>{{$t('views.application.show.databaseConnection')}}</b> - {{item.databaseConnection.title}}
    </p>
    <p v-if="item.server">
      <b>{{$t('views.application.show.server')}}</b> - {{item.server.title}}
    </p>
    <p v-if="item.SSHReturn" class="mb-0">
      <b>{{$t('views.application.show.SSHReturn')}}</b>
    </p>
    <b-table
      striped hover
      :bordered="true"
      :borderless="true"
      v-if="item.sqlScriptExecutedApplication && item.sqlScriptExecutedApplication.length > 0"
      :fields="executedApplicationFields"
      :items="item.sqlScriptExecutedApplication">
      <template v-slot:cell(createdAt)="data">
        {{$moment(data.item.sqlScriptExecuted.createdAt).format(DATETIMEFORMATTYPE)}}
      </template>
      <template v-slot:cell(sqlScriptExecuted)="data">
        <router-link :to="{name: 'SqlScriptExecutedShow', params: { id: data.item.sqlScriptExecuted['@id'] }}">
          {{data.item.sqlScriptExecuted.sqlScript}}
        </router-link>
      </template>
    </b-table>
    <div v-if="item.externalData">
      <active-agreements-chart-box v-if="item.externalData.activeAgreements" :data-incoming="item.externalData.activeAgreements"/>
      <active-user-datain-groups-chart-box v-if="item.externalData.activeGroupUserdata"  :data-incoming="item.externalData.activeGroupUserdata"/>
    </div>
  </div>

</template>

<script>
import activeAgreementsChartBox from '@/components/Dashboard/Views/IAMBundle/application/components/activeAgreementsChartBox'
import activeUserDatainGroupsChartBox from '@/components/Dashboard/Views/IAMBundle/application/components/activeUserDatainGroupsChartBox'
import { DATETIMEFORMATTYPE } from '@/config/datetimeFormatType'
import { mapActions, mapGetters } from 'vuex'
import { applicationStatuses } from '@/utils/const/applicationStatuses'
import Loader from '../../../Layout/Loader'

export default {
  components: {
    Loader,
    activeUserDatainGroupsChartBox,
    activeAgreementsChartBox
  },
  props: ['data'],
  data () {
    return {
      DATETIMEFORMATTYPE,
      executedApplicationFields: [
        {
          key: 'sqlScriptExecuted',
          label: this.$lang.t('views.application.show.sqlScriptExecuted')
        },
        {
          key: 'executeReturn',
          label: this.$lang.t('views.application.show.executeReturn')
        },
        {
          key: 'createdAt',
          label: this.$lang.t('views.application.show.executedAt'),
          sortable: true
        }
      ],
      applicationStatuses: applicationStatuses
    }
  },

  computed: {
    item () {
      return this.data || this.retrieved
    },
    ...mapGetters({
      deleteError: 'application/del/error',
      error: 'application/show/error',
      isLoading: 'application/show/isLoading',
      retrieved: 'application/show/retrieved',
      currentPage: 'application/list/currentPage'
    })
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    if (this.$route.name === 'ApplicationShow') {
      this.retrieve(decodeURIComponent(this.$route.params.id))
    }
  },

  methods: {
    ...mapActions({
      del: 'application/del/del',
      reset: 'application/show/reset',
      retrieve: 'application/show/retrieve'
    }),

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'ApplicationList' }))
      }
    }
  }
}
</script>

<style scoped>

</style>
